import { render } from "./RoobetChallengesSection.vue?vue&type=template&id=225351e0"
import script from "./RoobetChallengesSection.vue?vue&type=script&lang=js"
export * from "./RoobetChallengesSection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__